var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00018 7.99255e-05C2.23383 -0.000376864 2.46027 0.0809983 2.64018 0.23008L8.00018 4.71008L13.3702 0.390081C13.4725 0.307015 13.5902 0.244984 13.7165 0.207552C13.8428 0.17012 13.9753 0.158026 14.1064 0.171966C14.2374 0.185904 14.3644 0.225602 14.48 0.288775C14.5956 0.351949 14.6977 0.437354 14.7802 0.540081C14.8632 0.642369 14.9253 0.760065 14.9627 0.886404C15.0001 1.01274 15.0122 1.14523 14.9983 1.27626C14.9844 1.40729 14.9447 1.53427 14.8815 1.64991C14.8183 1.76555 14.7329 1.86756 14.6302 1.95008L8.63018 6.78008C8.45125 6.92716 8.2268 7.00757 7.99518 7.00757C7.76355 7.00757 7.53911 6.92716 7.36018 6.78008L1.36018 1.78008C1.25892 1.69613 1.17522 1.59303 1.11387 1.47668C1.05252 1.36034 1.01472 1.23303 1.00264 1.10205C0.990567 0.971075 1.00445 0.839002 1.04349 0.713399C1.08254 0.587795 1.14598 0.471128 1.23018 0.37008C1.32323 0.255367 1.44054 0.162692 1.57368 0.0987175C1.70682 0.0347426 1.85247 0.00105648 2.00018 7.99255e-05Z",
    fill: "#96A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.852c85cd7114772f030e1739098dcf3a.svg";
export { ForwardRef as ReactComponent };